<div class="radio {{id}}"
     [id]="id"
     [class.is-checked]="isChecked"
     [class.is-disabled]="disabled"
     (click)="onChange()"
     (keydown.space)="$event.stopPropagation(); $event.preventDefault(); onChange()"
     tabindex="0">
    <span class="radio-icon">
        <i *ngIf="isChecked"></i>
    </span>
    <span class="radio-label">
        <ng-content></ng-content>
    </span>
</div>
